import * as React from "react";
import {injectIntl, InjectedIntlProps, FormattedMessage} from "react-intl";
import {Tabs, message, Select} from "antd";
import NavGoBack from "../NavGoBack";
import ConnectDetail from "./ConnectDetail";
import {RouteComponentProps} from "react-router";
import TimeDetail from "./TimeDetail";
import {observer} from "mobx-react";
import {logStore} from "../../../models/LogStore";
import {consoleApi} from "../../../apiMiddleware";
import moment from "moment";
const { TabPane } = Tabs;
export type LogSearchDetailProps = RouteComponentProps<{uuid: string, startTime: string}> & InjectedIntlProps;
export type LogSearchDetailStates = {
    date: any;
    roomDosageTimeArray: any[],
};
const {Option} = Select;
@observer
class LogSearchDetail extends React.Component<LogSearchDetailProps, LogSearchDetailStates> {
    public constructor(props: LogSearchDetailProps) {
        super(props);
        const date = new Date().getDate();
        this.state = {
            date: date,
            roomDosageTimeArray: [],
        };
    }
    public async componentDidMount(): Promise<void> {
        const {uuid} = this.props.match.params;
        await this.handleAllRoom(uuid);
    }

    private handleAllRoom = async (value: string): Promise<void> => {
        try {
            const resp = await consoleApi.data.getRoomDataDetail(value);
            if (resp.code === 200 && resp.data.length > 0) {
                this.setState({roomDosageTimeArray: resp.data});
            } else {
                message.info("该房间尚未参数或者没有计量信息");
            }
        } catch (err) {
            message.error(`${err}`);
        }
    }
    private handleSelectChange = (date: any): void => {
        logStore.selectedDate = date;
    }
    public render(): React.ReactNode {
        const {uuid, startTime} = this.props.match.params;
        const { intl } = this.props;
        const {roomDosageTimeArray} = this.state;
        const currentDate = moment(parseInt(startTime)).startOf("day").valueOf();
        const option = roomDosageTimeArray.map((data: any, index: number) => {
            return (
                <Option key={`option-${index}`} value={data.timestamp}>{moment(data.timestamp).format("L")}</Option>
            );
        });
        const operations =  <Select style={{marginRight: 20}}
                                    size={"small"}
                                    defaultValue={currentDate}
                                    onChange={this.handleSelectChange}>
                            {option}</Select>;
        return (
            <>
                <NavGoBack title={<FormattedMessage id="log-details"/>}/>
                <div className="product-center-box">
                    <div className="portal-room-outbox">
                        <div className="portal-room-chart">
                            <div className="portal-room-box-mid">
                                <Tabs style={{marginLeft: 20, marginRight: 20}} defaultActiveKey="1" tabBarExtraContent={operations}>
                                    <TabPane tab={intl.formatMessage({id: "connection-log"})} key="1">
                                        <ConnectDetail uuid={uuid} startTime={startTime}/>
                                    </TabPane>
                                    <TabPane tab={intl.formatMessage({id: "dosage-log"})} key="2">
                                        <TimeDetail startTime={startTime} uuid={uuid}/>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

}

export default injectIntl(LogSearchDetail);



// WEBPACK FOOTER //
// ./src/components/portal/logSearch/LogSearchDetail.tsx